import axios from "axios";
import {
  DeleteDeliveryLocation_API_URL,
  GetDeliveryLocation_API_URL,
  SaveDeliveryLocation_API_URL,
  UpdateDeliveryLocation_API_URL,
  GetMosqueOrdersList_API_URL,
} from "./config";

// This function saves the delivery location using the Zulal Web API
export const saveDeliveryLocation = async (data) => {
  try {
    const response = await axios.post(SaveDeliveryLocation_API_URL, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error saving delivery location: ", error.message);
    throw error;
  }
};

// This function fetches the delivery locations using the Zulal Web API
// export const getDeliveryLocations = async (data) => {
//   try {
//     console.log(`customer Code from Zulal Web API: ${data.customerCode}`);
//     const response = await axios.get(GetDeliveryLocation_API_URL, {
//       params: {
//         customerCode: data.customerCode,
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error fetching delivery locations: ", error.message);
//     throw error;
//   }
// };

export const getDeliveryLocations = async (customerCode) => {
  try {
    //    console.log(`customerCode from Zulal Web API: ${customerCode}`);

    const response = await axios.get(GetDeliveryLocation_API_URL, {
      params: { customerCode },
    });

    // console.log("******************");
    // console.log(response.status);
    // console.log("******************");

    if (response.status === 200) {
      return response.data || [];
    } else {
      return [];
    }
  } catch (error) {
    return {
      status: "error",
      message: error.message,
      data: [],
    };
  }
};

// This function update the delivery location using the Zulal Web API
export const updateDeliveryLocation = async (data) => {
  try {
    const response = await axios.put(UpdateDeliveryLocation_API_URL, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating delivery location: ", error.message);
    throw error;
  }
};

// This function delete the delivery location using the Zulal Web API
export const deleteDeliveryLocation = async (data) => {
  try {
    const response = await axios.delete(DeleteDeliveryLocation_API_URL, {
      data: data,
      withCredentials: true, // Include credentials if needed
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting delivery location: ", error.message);
    throw error;
  }
};

// This function fetches the Mosque Orders using the Zulal Web API by CustomerCode
export const getMosqueOrders = async (data) => {
  try {
    //console.log(data);
    const response = await axios.get(GetMosqueOrdersList_API_URL, {
      params: {
        customerCode: data.encrypteCustomerInfo,
        secretKey: data.secretKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching mosque orders: ", error.message);
    throw error;
  }
};
